import { getRatingData } from '../api/ratings';
import { RatingData } from '../types';
import { trackGetDataError, trackGetDataSuccess } from './tracking';

export const getDataAction = async (
    organizer_id: string,
    filterRating: boolean,
    trackCategory: string,
    setRatingObject: Function,
    locale: string,
) => {
    await getRatingData({ organizer_id, filterRating, locale })
        .then((response: RatingData) => {
            trackGetDataSuccess(trackCategory, organizer_id);
            setRatingObject(response);
        })
        .catch((error: any) => {
            trackGetDataError(trackCategory, organizer_id, error);
        });
};
